import { defineStore } from 'pinia';
import { ref, computed } from 'vue';
import { fetchMe, logout as apiLogout, type MeResponseAuthenticated } from '@/api/auth';

export const useAuthStore = defineStore('auth', () => {
  const user = ref<MeResponseAuthenticated['user'] | null>(null);
  const loaded = ref(false);
  const loading = ref(false);

  const isAuthenticated = computed(() => user.value !== null);
  const roles = computed<string[]>(() => user.value?.roles ?? []);

  function hasRole(...allowed: string[]): boolean {
    return allowed.some((r) => roles.value.includes(r));
  }

  async function fetchMeNow(): Promise<void> {
    loading.value = true;
    try {
      const me = await fetchMe();
      user.value = me.authenticated ? me.user : null;
    } catch {
      user.value = null;
    } finally {
      loaded.value = true;
      loading.value = false;
    }
  }

  async function logout(): Promise<void> {
    try {
      await apiLogout();
    } finally {
      user.value = null;
    }
  }

  return {
    user,
    loaded,
    loading,
    isAuthenticated,
    roles,
    hasRole,
    fetchMe: fetchMeNow,
    logout,
  };
});
